function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 5L3 10L5 10L5 6L8.24264 9.24264L9.65685 7.82843L6.82843 5L10 5L10 3L5 3L3 3L3 5ZM19 3L14 3L14 5L18 5L14.7574 8.24264L16.1716 9.65685L19 6.82843L19 10L21 10L21 5L21 3L19 3ZM21 14L21 19L21 21L19 21L14 21L14 19L17.1716 19L14.3431 16.1716L15.7574 14.7574L19 18L19 14L21 14ZM5 21L10 21L10 19L6 19L9.24264 15.7574L7.82843 14.3431L5 17.1716L5 14L3 14L3 19L3 21L5 21Z",
  fill: "currentColor"
});

var SvgFs = function SvgFs(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFs, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fs.e67600e3.svg";
export { ForwardRef as ReactComponent };